import React from 'react'

const Invitation: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/invitation.svg" alt="invitation"/>
  )
}

export default Invitation